import { SimpleModal } from '@/app/components/Modal';
import { t } from 'i18next';
import moment from 'moment';
import styles from './styles.module.scss';
import { useNavigate } from 'react-router-dom';

export default function BannerDetailsModal({ banner, open, onClose }) {
  const navigate = useNavigate();

  return (
    <SimpleModal
      show={open}
      onClose={onClose}
      contentClassName="simple-modal__content--lg "
    >
      <h2>Banner informativo</h2>
      <div className="card__header-img-wrapper">
        <img
          className="card__header-img"
          src={banner?.image?.url}
          alt="Banner"
          style={{ height: '250px' }}
        />
      </div>
      <div className={styles.container}>
        <div className={styles.item}>
          <div className={styles.title}>Título</div>
          <div>{banner?.title}</div>
        </div>

        <div className={styles.item}>
          <div className={styles.title}>Perfis associados</div>
          <div>{banner?.profiles?.map(profile => profile.name).join(', ')}</div>
        </div>

        <div className={styles.item}>
          <div className={styles.title}>Status</div>
          <div>
            <div className={`badge badge--tiny badge--${banner?.['published-at'] ? 'success' : 'warning'}`}>{banner?.['published-at'] ? 'Publicado' : 'Não publicado'}</div>
          </div>
        </div>

        <div className={styles.item}>
          <div className={styles.title}>Período</div>
          <div>
            {moment(banner?.['start-date']).format('DD/MM/YYYY')} - {moment(banner?.['end-date']).format('DD/MM/YYYY')}
          </div>
        </div>

        <div className={styles.item}>
          <div className={styles.title}>Link</div>
          <div style={{ textDecoration: 'underline' }}>{banner?.link || '-'}</div>
        </div>

        <div className={styles.item}>
          <div className={styles.title}>Texto do botão</div>
          <div>{banner?.label || '-'}</div>
        </div>
      </div>

      <button
        type="submit"
        className="btn btn--outline"
        style={{ width: '150px', float: 'right' }}
        onClick={() => navigate(`/banners/novo/${banner.id}`)}
      >
        {t('button.edit')}
      </button>
    </SimpleModal>
  );
}
